export enum EnumEstadoOperacion {
  Borrador = 1,
  Repartido,
  Programado,
  ProgramadoOKSinContrato,
  ProgramadoKO,
  RepartidoSinContrato,
  Enviado,
  DP,
  FP,
  FD,
  Anulado
}
